var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('router-link',{attrs:{"to":"/order"}},[_c('span',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.productCart.length)+" ")]),_c('fab',{attrs:{"position":_vm.position,"bg-color":_vm.bgColor,"main-icon":_vm.mainIcon}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }